import {
  Body,
  ControlledRoot,
  Label,
  Menu,
  MenuFooter,
  MenuItems,
  Root,
  SearchableBody,
  SearchBar,
  Trigger,
  TriggerText,
} from './composableComponents'

export { selectors as singleSelectSelectors } from './composableComponents'

export const SingleSelect = {
  Body,
  ControlledRoot,
  Label,
  Menu,
  MenuFooter,
  MenuItems,
  Root,
  SearchableBody,
  SearchBar,
  Trigger,
  TriggerText,
}
